<script>
export default {
    name: "PatientChargesModal",

    props: {
        showModal: Boolean,
        patient: Object,
    },

    methods: {

        printPatientCharges() {

            window.open(`/reports/patients/patient-charges/print?patientID=${this.patient.patientID}&visitNo=${this.patient.visitNo}`, '_blank', `PatientCharges`, "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="w-1/2">
  <template v-slot:title>
    <h5 class="text-sm font-bold">Patient Charges</h5>
  </template>
  <template v-slot:modal-body>
    <div class="flex md:flex-row sm: flex-col p-1 bg-indigo-400 my-2">
        <div class="flex-1">
            <h5 class="font-semibold text-sm">Name: {{ patient.names }}</h5>
        </div>
        <div class="flex-1">
            <h5 class="font-semibold text-sm">IP NO: {{ patient.ipfileno }}</h5>
        </div>
        <div class="flex-1">
            <h5 class="font-semibold text-sm">OP NO: {{ patient.opfileno }}</h5>
        </div>
        <div class="flex-1">
            <h5 class="font-semibold text-sm">Diagnosis: {{ patient.diagnosis }}</h5>
        </div>
        <div class="flex-1">
            <h5 class="font-semibold text-sm">Seen By: {{ patient.userName }}</h5>
        </div>
    </div>
    <div class="w-full overflow-auto">
        <table class="table table-bordered table-hover">
            <thead class="text-sm bg-indigo-400">
                <tr>
                    <th class="p-tiny">Date</th>
                    <th class="p-tiny">User</th>
                    <th class="p-tiny">Item</th>
                    <th class="p-tiny">Qty</th>
                    <th class="p-tiny">Total</th>
                    <th class="p-tiny">Balance</th>
                </tr>
            </thead>
            <tbody class="text-xs">
                <tr v-for="(charge, idx) in patient.charges" :key="idx">
                    <td class="p-tiny">{{ charge.sysDate | dateFormat }}</td>
                    <td class="p-tiny">{{ charge.userName }}</td>
                    <td class="p-tiny">{{ charge.itemName }}</td>
                    <td class="p-tiny">{{ charge.quantity }}</td>
                    <td class="p-tiny">{{ charge.grandTotal | numberFormat }}</td>
                    <td class="p-tiny">{{ charge.balance }}</td>
                </tr>
            </tbody>
        </table>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button 
        class="btn-danger btn-sm text-xs rounded mr-8" 
        @click="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Cancel</button>
    <button 
        class="btn-sm btn-info text-xs rounded" 
        @click.prevent="printPatientCharges">
            <i class="fa fa-print"></i> Print</button>
  </template>
</tail-modal>
</template>